// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Provider } from 'react-redux';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

import './index.css';
import { store } from 'libs/data-store';
import App from 'app/app';

const container = document.getElementById('root');
const root = createRoot(container!);

// events
/*
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    console.log('restored from the bfcache');
  } else {
    console.log('loaded');
  }
});

window.addEventListener('pagehide', (event) => {
  if (event.persisted) {
    console.log('*might* entered bfcache');
  } else {
    console.log('discarded');
  }
});
*/

root.render(
  <Provider store={store}>
    {/* <StrictMode> */}
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ReactNotifications />
        <App />
      </LocalizationProvider>
    {/* </StrictMode> */}
  </Provider>
);
